import { createActions, createReducer } from 'reduxsauce'

import DetalhesPrestacaoService from '../../servicos/DetalhesPrestacaoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesPrestacaoInicio: [],
    buscaDetalhesPrestacaoSucesso: ['detalhesPrestacao'],
    buscaDetalhesPrestacaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
}

// Ação para busca completa
Creators.buscaDetalhesPrestacao = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesPrestacaoInicio())
        let serv = new DetalhesPrestacaoService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaDetalhesPrestacaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesPrestacaoErro(error)))
    }
}

const buscaDetalhesPrestacaoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesPrestacaoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesPrestacaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesPrestacao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_PRESTACAO_INICIO]: buscaDetalhesPrestacaoInicio,
    [Types.BUSCA_DETALHES_PRESTACAO_ERRO]: buscaDetalhesPrestacaoErro,
    [Types.BUSCA_DETALHES_PRESTACAO_SUCESSO]: buscaDetalhesPrestacaoSucesso,
})
